import * as globals from '@wandb/weave/common/css/globals.styles';
// @todo: Migrate to 'Icon' from @wandb/components. For more details see:
// https://wandb.github.io/components/?path=/docs/migration-guide--docs
// eslint-disable-next-line wandb/no-deprecated-imports
import {Icon} from '@wandb/weave/components/Icon';
// eslint-disable-next-line wandb/no-deprecated-imports
import {Button} from 'semantic-ui-react';
// eslint-disable-next-line wandb/no-deprecated-imports
import styled from 'styled-components';

export const MissingText = styled.div`
  color: ${globals.gray600};
  margin-bottom: 16px;
`;

export const Prompt = styled.div``;

export const PromptHeader = styled.h2`
  font-size: 24px;
  font-weight: 600;
  line-height: 30px;
  margin-bottom: 8px;
`;

export const PromptBody = styled.div`
  line-height: 20px;
`;

export const PromptButton = styled(Button)`
  &&& {
    margin: 24px 0;
  }
`;

export const PromptHint = styled.div`
  display: flex;
  align-items: center;
  font-size: 14px;
  line-height: 18px;
`;

export const PromptHintIcon = styled(Icon)`
  font-size: 20px;
  margin-right: 3px;
`;

export const PromptHintBody = styled.div``;

export const Container = styled.div`
  background-color: ${globals.gray200};
  border-radius: 3px;
  max-width: 920px;
  @media (max-width: ${globals.MOBILE_WIDTH}px) {
    display: flex;
    flex-direction: column;
    padding: 20px;
    ${Prompt} {
      margin-top: 32px;
    }
    i {
      transform: rotate(90deg);
    }
  }
  @media (min-width: ${globals.MOBILE_WIDTH}px) {
    column-gap: 40px;
    display: grid;
    grid-template-columns: 224px 1fr;
    padding: 32px;
  }
`;

export const CardDescription = styled.div`
  word-wrap: break-word;
  overflow-wrap: break-word;
  white-space: normal;
  width: 100%;
  color: ${globals.MOON_500};
  font-family: Source Sans Pro;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 140%;
  align-items: center;
`;

export const TooltipHeader = styled.h3`
  color: ${globals.white};
  font-size: 20px;
  line-height: 25px;
  font-weight: 600;
  margin-bottom: 8px;
`;

export const TooltipBody = styled.div`
  color: ${globals.gray300};
  font-size: 16px;
  line-height: 20px;
  margin-bottom: 16px;
`;

export const TooltipImage = styled.img`
  width: 318px;
  height: 327px;
`;
